// @flow
import React from "react";
import Spinner from "react-spinkit";
import "./SendingLabel.scss";

type SendingLabelProps = {
    sending: boolean,
    label: string,
    sendingText: string,
};

// content of a send button: while the request runs, a spinner takes the label's place
// without changing the button's width; screen readers get the sending text instead
const SendingLabel = ({sending, label, sendingText}: SendingLabelProps) => <React.Fragment>
    <span className={sending ? "hpm-sendingLabel hpm-sendingLabel-hidden" : "hpm-sendingLabel"}>{label}</span>
    {sending && <React.Fragment>
        <Spinner name="ball-beat" fadeIn="none" className="hpm-sendingSpinner" data-testid="sendingSpinner" aria-hidden="true"/>
        <span className="hpm-sendingAnnouncement" role="status">{sendingText}</span>
    </React.Fragment>}
</React.Fragment>;

export default SendingLabel;
